module.exports = __webpack_public_path__ + "img/1.ba67ae06.png";